import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { MediaService } from 'src/app/shared/services/media.service';
import { UntypedFormBuilder } from '@angular/forms';
import { Observable } from 'rxjs';
import { ShowDocumentComponent } from 'src/app/feature-module/documents/component/show-document/show-document.component';
import { Constants } from 'src/app/shared/model/Constants';

import { DocumentService } from 'src/app/feature-module/documents/service/document.service';
import { DocumentInfoSearchResultItem } from '../../models/DocumentInfoSearchResultItem';
import { SearchDocumentInfoCriteria } from '../../models/SearchDocumentInfoCriteria';
import { map, switchMap, tap } from 'rxjs/operators';
import { UploadFilesSettings } from '../../models/UploadFilesSettings';
import { CustomDialogSettings } from 'src/app/shared/model/CustomDialogSettings';
import { CustomDialogService } from 'src/app/shared/services/custom-dialog.service';
import { UiNotificationService } from 'src/app/external-ui-shared/services/ui-notification.service';
import { environment } from 'src/environments/environment';
import { ExportDocumentsData } from '../../models/ExportDocumentData';


@Component({
  selector: 'app-show-documents-multiple',
  templateUrl: './show-documents-multiple.component.html',
  styleUrls: ['./show-documents-multiple.component.scss']
})
export class ShowDocumentsMultipleComponent implements OnInit {

  constructor(private fb: UntypedFormBuilder,
    private documentService: DocumentService,
    private customDialogService: CustomDialogService,
    private uiNotification: UiNotificationService,
    private mediaService: MediaService
  ) {

  }

  searchDocumentInfoCriteria: SearchDocumentInfoCriteria;
  error: string;
  isLoading: boolean;
  isFileGenerating: boolean;

  documentInfos$: Observable<DocumentInfoSearchResultItem[]>;

  editMode: boolean;
  @Input() public referenceId = "";
  @Input() public referenceType = 0;
  @Input() public documentKindId = 0;
  @Input() public rowsPerPage: number = Constants.MaxInt;
  @Input() public sortDirection = '';
  @Input() allowUpload: false;
  @Input() uploadFilesSettings: UploadFilesSettings;
  @Input() showNameColumn = true;
  @Input() showInfoColumn = true;

  @Output() newItemUploadedEvent = new EventEmitter<string>();


  @ViewChild("showDocumentsMultipleDialog", { read: ViewContainerRef })
  public containerRef: ViewContainerRef;

  ngOnInit(): void {
    this.initForm();
    this.loadDocuments();
  }

  initForm(): void {

    this.searchDocumentInfoCriteria = {
      referenceType: this.referenceType,
      referenceId: this.referenceId?.toString(),
      documentKindId: this.documentKindId,
      pageNumber: 1,
      rowsPerPage: this.rowsPerPage,
      sortDirection: this.sortDirection
    }
  }

  loadDocuments() {
    this.isLoading = true;
    this.documentInfos$ = this.documentService.searchDocumentInfo(this.searchDocumentInfoCriteria).pipe(
      tap(() => { this.isLoading = false; }));
  }


  showContent(documentInfoSearchResultItem: DocumentInfoSearchResultItem) {

    const dialogSettings: CustomDialogSettings = {
      content: ShowDocumentComponent,
      minHeight: '60vh',
      minWidth: '60vw',
      maxHeight: '80vh',
      maxWidth: '80vw',
      appendTo: this.containerRef,
      title: ' ',
      dialogInputs: {
        documentInfo: documentInfoSearchResultItem
      }
    };

    this.customDialogService.showDialog(dialogSettings);
  }

  showContentInExternalWindow(documentId) {
    let webAppPath = '';
    if(environment.wepAppName){
      webAppPath = "/" + environment.wepAppName;
    }
    
   const documentLink = window.location.origin + webAppPath + '/documentCenter/documentContent/' + documentId;
    const width = this.mediaService.getFullHdRelativeWidth(0.75);
    const height = this.mediaService.getFullHdRelativeHeight(0.9);
    window.open(documentLink, "_documentContentViewer", 'width=' + width + ',height=' + height + ',toolbar=0,location=0,resizable=1,scrollbars=1'); return false;
  }

  remove(documentInfoId: string) {
    this.customDialogService.actionWithConfirmation('claims-center.claimDocumentation.doYouReallyWantToDeleteThisDocument',
    () => {
      this.documentService.removeDocument(documentInfoId).subscribe(() => this.loadDocuments());
        },
        this.containerRef);

   
  }

  downloadSingleFile(documentInfo: DocumentInfoSearchResultItem) {

    const task = this.uiNotification.showRunningOperation('operations.singleFilesExportOngoing');
    this.isFileGenerating = true;

    const ids = [documentInfo.id];
    this.documentService.getExportDocumentsData(ids).pipe(
      switchMap(
        (r: ExportDocumentsData) => {
          return this.documentService.downloadDocument(r.exportDocumentItems[0].id).pipe(
            map((content:Blob) => ({content: content, exportDocumentInfo:  r.exportDocumentItems[0]})
          ))
        })).subscribe(
          (res) => {
            const content = res.content;
            const exportDocumentInfo = res.exportDocumentInfo;
            const downloadLink = document.createElement('a');
            downloadLink.href = window.URL.createObjectURL(new Blob([content], { type: 'application/octet-stream' }));
            downloadLink.setAttribute('download', exportDocumentInfo.nameForExport);
            document.body.appendChild(downloadLink);
            downloadLink.click();
            downloadLink.parentNode.removeChild(downloadLink);

            task.hide();
            this.isFileGenerating = false;
          });
  }


  /* UPLOAD INTEGRATION */
  uploadedEvent(ev: string) {
    this.loadDocuments();
    this.newItemUploadedEvent.emit(ev);
  }

}



